import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IonSearchbar } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { MapType } from 'src/app/sismap-reference/domain/map-type.enum';
import { SisMapReference } from 'src/app/sismap-reference/domain/sismap-reference.model';
import { SisMapReferenceService } from 'src/app/sismap-reference/sismap-reference.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sis-map-reference',
  templateUrl: './sismap-reference.page.html',
  styleUrls: ['./sismap-reference.page.scss'],
  standalone: false,
})
export class SisMapReferencePage implements OnInit, AfterViewInit {
  @ViewChild(IonSearchbar) searchbar: IonSearchbar | undefined;

  maps: SisMapReference[] = [];
  filteredMaps: SisMapReference[] = [];
  environment = environment;

  constructor(
    private sisMapReferenceService: SisMapReferenceService,
    private translateService: TranslateService,
    private title: Title,
  ) {}

  async ngAfterViewInit(): Promise<void> {
    if (this.searchbar) {
      await this.searchbar.getInputElement();
      await new Promise(requestAnimationFrame);
      await this.searchbar.setFocus();
    }
  }

  async ngOnInit(): Promise<void> {
    const maps = await this.sisMapReferenceService.requestSisMapReferenceMaps();
    this.maps = maps.sort((a, b) => a.tenant.localeCompare(b.tenant) || a.name.localeCompare(b.name));
    this.filteredMaps = [...this.maps];

    this.title.setTitle(`${environment.titlePrefix}SisMaps`);
  }

  filterList(event: Event): void {
    const target = event.target as HTMLIonSearchbarElement;
    const query = (target.value || '').toLowerCase();
    this.filteredMaps = this.maps.filter((map) => {
      const tenantMatch = map.tenant.toLowerCase().includes(query);
      const nameMatch = map.name.toLowerCase().includes(query);
      const seasonText = this.getSeasonText(map);
      const seasonTranslated = this.translateService.instant(seasonText).toLowerCase();
      return tenantMatch || nameMatch || seasonTranslated.includes(query);
    });
  }

  getBlobUrl(map: SisMapReference): string {
    return `${this.environment.baseUrlPublicAssets}/logo/${map.logoFilename}`;
  }

  getSeasonText(map: SisMapReference): string {
    return `sismap.reference.term.season.${map.season}`;
  }

  openLink(map: SisMapReference): void {
    const path = MapType[map.mapType]?.toLowerCase();

    const url = path
      ? `${environment.sisControlPublicUrl}/${map.sisId}/${path}/${map.areaUrlName}/${map.season}`
      : `${environment.sisControlPublicUrl}/error`;

    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
